import Loading from '../components/Loading';
import Activity from '../components/Activity';
import { useGlobalContext } from '../context/GlobalContext';
import { useEffect } from 'react';
import styled from 'styled-components';

const Activities = ({ amount }) => {
  const { activities_loading, activities_error, activities, getActivities } =
    useGlobalContext();

  useEffect(() => {
    getActivities();
  }, []);

  if (activities_loading) {
    return <Loading />;
  }

  if (activities_error) {
    return (
      <h2 className='activities-error'>
        Fout bij het laden van de activiteiten...
      </h2>
    );
  }

  const activitiesReduced = amount ? activities.slice(0, amount) : activities;
  const shownActivities = activitiesReduced.filter((activity) => {
    if (activity.showActivity) {
      return activity;
    }
    return null;
  });

  return (
    <ActivitiesContainer>
      <div className='activities'>
        <h1>Geplande activiteiten</h1>
        <div>
          <section>
            {shownActivities.map((activity) => {
              return <Activity {...activity} key={activity._id} />;
            })}
          </section>
        </div>
      </div>
    </ActivitiesContainer>
  );
};

const ActivitiesContainer = styled.div`
  h1,
  h2 {
    color: var(--primaryBtnColor);
  }
`;

export default Activities;
